import { render, staticRenderFns } from "./ManageRolesModal.vue?vue&type=template&id=efa1f9fe&scoped=true&"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js&"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa1f9fe",
  null
  
)

export default component.exports